import { useDisclosure } from '@mantine/hooks'
import { IconTrash } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { DeploymentOverviewApp } from '@/types/deploymentGroup'
import { CrudAction, Resource } from '@/types/permissions'
import { ActionButton } from '../DeploymentList/DeploymentListActions'
import { AppDeploymentDeleteConfirm } from './AppDeploymentDeleteConfirm'

type AppDeploymentActionsProps = {
  app: DeploymentOverviewApp
}

export const AppDeploymentActions = ({ app }: AppDeploymentActionsProps) => {
  const intl = useIntl()
  const [isDeleteOpen, { open, close }] = useDisclosure(false)
  const [canDeleteDeployment] = useHasPermissions(Resource.Deployments, [
    CrudAction.Delete
  ])

  if (!canDeleteDeployment) {
    return null
  }

  return (
    <>
      <ActionButton
        tooltip={intl.formatMessage({ id: 'deployments.app.delete.tooltip' })}
        icon={<IconTrash style={{ width: '70%', height: '70%' }} />}
        color="red"
        onClick={open}
      />

      <AppDeploymentDeleteConfirm
        opened={isDeleteOpen}
        app={app}
        onClose={close}
      />
    </>
  )
}
